import { render } from "./PaginationOld.vue?vue&type=template&id=4d04a6f7"
import script from "./PaginationOld.vue?vue&type=script&lang=js"
export * from "./PaginationOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__